import { useNavigate } from 'react-router-dom';

export default function RoomsHero() {
  const navigate = useNavigate();

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="domov"
      className="relative w-full min-h-[560px] md:min-h-[680px] lg:min-h-[760px] flex items-center overflow-hidden bg-background-950"
    >
      <img
        src="https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/5d867f2f3cafc4c2fe28665be2db15e4.png"
        alt="Dvoposteljna soba v Gostilni Marta"
        title="Sobe in prenočišča – Gostilna Marta"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(199,152,60,0.18),transparent_55%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_85%_75%,rgba(199,152,60,0.12),transparent_50%)]"></div>
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            'linear-gradient(to right, rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.6) 1px, transparent 1px)',
          backgroundSize: '64px 64px',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-950/60 to-background-950/85"></div>

      <div className="relative z-10 w-full px-5 md:px-10 lg:px-14 pt-28 md:pt-32 pb-16 md:pb-20">
        <div className="max-w-4xl mx-auto text-center">
          <p className="hero-animate font-label text-xs tracking-extra-wide text-primary-400 font-medium uppercase mb-4 md:mb-6">
            Nastanitev · Gostilna Marta
          </p>
          <h1 className="hero-animate font-heading text-4xl sm:text-5xl md:text-7xl font-light text-white tracking-wide mb-4 md:mb-6">
            Sobe in prenočišča
          </h1>
          <p className="hero-animate font-body text-sm md:text-lg text-white/70 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
            Prijetna nastanitev v mirnem okolju Cvetkovcev. Prebudite se ob domačem zajtrku in
            uživajte v toplini gostilne iz bližine.
          </p>
          <div className="hero-animate flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 w-full px-6 sm:px-0 max-w-sm sm:max-w-none mx-auto">
            <button
              onClick={() => scrollTo('sobe')}
              className="w-full sm:w-auto px-7 py-4 sm:py-3 bg-primary-500 hover:bg-primary-600 text-background-950 text-sm sm:text-xs font-label font-semibold tracking-extra-wide transition-all duration-300 whitespace-nowrap cursor-pointer rounded-md sm:rounded-sm"
            >
              POGLEJ SOBE
            </button>
            <button
              onClick={() => scrollTo('booking')}
              className="w-full sm:w-auto px-7 py-4 sm:py-3 border border-white/40 hover:border-white/80 text-white text-sm sm:text-xs font-label font-medium tracking-extra-wide transition-all duration-300 whitespace-nowrap cursor-pointer rounded-md sm:rounded-sm hover:bg-white/10"
            >
              REZERVIRAJ ODDIH
            </button>
          </div>
        </div>

        <div className="hero-animate max-w-3xl mx-auto mt-12 md:mt-16 grid grid-cols-3 gap-4 md:gap-8 border-t border-white/10 pt-8">
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl text-primary-400 font-light">3</p>
            <p className="font-label text-[10px] md:text-xs tracking-wide text-white/50 uppercase mt-1">
              Vrste sob
            </p>
          </div>
          <div className="text-center border-x border-white/10">
            <p className="font-heading text-2xl md:text-3xl text-primary-400 font-light">2–4</p>
            <p className="font-label text-[10px] md:text-xs tracking-wide text-white/50 uppercase mt-1">
              Osebe na sobo
            </p>
          </div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl text-primary-400 font-light">14–23 m²</p>
            <p className="font-label text-[10px] md:text-xs tracking-wide text-white/50 uppercase mt-1">
              Površina sob
            </p>
          </div>
        </div>
      </div>

      <button
        onClick={() => navigate('/gostilna')}
        className="absolute bottom-6 right-5 md:right-8 z-10 inline-flex items-center gap-2 font-label text-[10px] md:text-xs tracking-extra-wide text-white/50 hover:text-primary-400 transition-colors duration-300 uppercase cursor-pointer"
      >
        <i className="ri-arrow-left-line"></i> Nazaj v gostilno
      </button>
    </section>
  );
}